// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-home-index-js" + "-" + "b2ef6ab50b19c2605f19" + ".js";
};